"use client";
import React, { useEffect, useState } from 'react';
import newpass from "./newpass.module.css";
import validator from '../utils/validator';
import { useRouter, useSearchParams } from 'next/navigation';
import { fetchWithLoader } from '../utils/api';
import { useAuthStore } from '../store/authstore';
import { useToastStore } from '../store/localapi';

export default function NewpasswordForm() {
  const user = useAuthStore((state)=>state.user)
  const { showToast } = useToastStore()
  const [newpassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const params = useSearchParams();
  const router = useRouter();
  const [showPassword, setShowPassword] = useState({
    newpassword: false,
    confirmPassword: false
  });

  
useEffect(() => {
  if (user || params.get('email') == null) {
    router.push('/');
  }
}, [user,params,router]);
  

  const [errors, setErrors] = useState({
    newpassword: "",
    confirmPassword: "" 
  });


  const matchpass = () => {
    setErrors((prev) => ({
      ...prev,
      confirmPassword:
        confirmPassword !== newpassword
          ? "Passwords do not match"
          : ""
    }));
  }

  const validate = validator();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {

    e.preventDefault();
    const newErrors = {
      newpassword: "",
      confirmPassword: ""
    };
    const passerr = validate.password(newpassword)
    if (passerr) {
      newErrors.newpassword = passerr
    }
    if (newpassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match"
      return
    }
    setErrors(newErrors);
    
    if (Object.values(newErrors).some((error) => error !== "") || newpassword == "") {
      return;
    }

    fetchWithLoader('drama_change_password.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_email: params.get('email'),
        user_password: newpassword
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log(data)
        if (data?.data.ErrorCode == 0) {
          showToast("Password Changed Successfully", "success");
          router.push(`/login/?email=${data?.data?.Data?.user_email}`);
        } else if (data?.data.ErrorMessage == "Email not Exist") {
          showToast("Email not Exist", "error");
          // setTimeout(() => {
          //   router.push('/signup');
          // }, 1000);
        } else {
          setErrors((prev) => ({
            ...prev, newpassword: data?.data.ErrorMessage || "An error occurred"
          }));
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };


  return (
     <div className="setHight">
      <div className={`${newpass.newsignup} signUpSec`}>
        <div className="container">
          <div className="signupForm">
            <form onSubmit={handleSubmit}>
              <div className="titcenter"><h2 className={`${newpass.newsignuphead} heaing`}>New Password</h2></div>

              <div className="field">
                <div  className="password">
                  <input className="Pswrd" type={showPassword.newpassword ? "text" : "password"}
                    value={newpassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    onBlur={() => {
                      setErrors((prev) => ({ ...prev, newpassword: validate.password(newpassword) ?? '' }));
                    }}
                    name="Password" id="password" placeholder='Password*' required />
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                      <path d="M5.32263 8.38487C8.76609 8.50991 12.3768 8.18006 15.8014 8.37221C16.8155 8.42898 17.6076 8.88041 17.9731 9.72881C18.0981 10.0188 18.1556 10.3333 18.1556 10.6489L18.1541 18.2113C18.1541 18.846 17.8983 19.4601 17.4284 19.8874C17.0829 20.2015 16.6395 20.409 16.1462 20.4577L5.00543 20.4558C4.00247 20.3039 3.20009 19.4946 3.07275 18.4863L3.07659 10.6957C3.07697 9.60339 3.83601 8.64069 4.90763 8.42936C5.04225 8.4029 5.1811 8.38794 5.32263 8.38525V8.38487ZM11.6714 12.6311C10.3018 11.2634 8.22721 13.3161 9.52129 14.6831C9.61104 14.7778 9.86878 14.9155 9.88604 15.0068C9.92362 15.5625 9.83541 16.1812 9.88412 16.7293C9.96466 17.6325 11.2591 17.6551 11.342 16.7293C11.3922 16.1697 11.2963 15.5426 11.3466 14.9753C12.18 14.479 12.371 13.3299 11.6711 12.6311H11.6714Z" fill="#9B9D9C" />
                      <path d="M11.6714 12.6286C12.3714 13.3275 12.18 14.4766 11.3469 14.9729C11.2963 15.5401 11.3922 16.1672 11.3423 16.7268C11.2595 17.6527 9.96502 17.6301 9.88448 16.7268C9.83577 16.1791 9.92398 15.5605 9.88639 15.0043C9.86875 14.913 9.61101 14.7753 9.52164 14.6806C8.22756 13.3136 10.3018 11.2609 11.6714 12.6286Z" fill="#1F222B" />
                      <path d="M14.6314 2.65765C13.864 1.6915 12.5388 0.981563 11.3019 0.878773C10.9364 0.848473 10.2882 0.846938 9.9238 0.878773C8.53575 1.00036 7.17072 1.81922 6.39366 2.95413C5.4417 4.3441 5.13215 6.82118 5.20502 8.47272L7.42638 8.47904C7.35389 6.91226 7.71842 4.06679 9.38952 3.38447C10.2567 3.03046 11.537 3.08454 12.3175 3.6307C13.5744 4.51017 13.6568 6.2902 13.5989 7.68439L13.5552 8.54544L15.8653 8.37515L15.896 7.68439C15.9804 5.91816 15.7602 4.0783 14.6314 2.65765Z" fill="#9B9D9C" />
                    </svg>
                  </span>

                  {newpassword !== "" && <>
                    {!showPassword.newpassword && <span className="showEye"
                      onClick={() => setShowPassword((prev) => ({
                        ...prev, newpassword: true
                      }))}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path d="M17.664 0.484375L14.3328 3.81558C9.82084 0.613975 4.56004 2.48597 0.936035 9.48438C1.90564 11.3564 2.99524 12.854 4.15204 13.9964L0.936035 17.2124L2.20804 18.4844L18.936 1.75637L17.664 0.484375ZM9.03843 8.58197C8.53924 8.58197 8.13604 8.17877 8.13604 7.67957C8.13604 7.18037 8.53924 6.77718 9.03843 6.77718C9.53764 6.77718 9.94084 7.18037 9.94084 7.67957C9.94084 8.17877 9.53284 8.58197 9.03843 8.58197ZM11.76 6.38838C11.2272 6.07158 10.6032 5.88438 9.93604 5.88438C7.94884 5.88438 6.33604 7.49718 6.33604 9.48438C6.33604 10.1516 6.51844 10.7756 6.84004 11.3084L5.35683 12.7916C4.42564 11.9324 3.53764 10.8284 2.73604 9.48438C4.79044 6.03797 7.38244 4.08438 9.93604 4.08438C10.992 4.08438 12.0528 4.42998 13.08 5.06838L11.76 6.38838Z" fill="#9B9D9C" />
                        <path d="M16.9918 6.40234L15.811 7.58314C16.2718 8.15914 16.7182 8.78314 17.1358 9.48394C15.0814 12.9303 12.4894 14.8839 9.93581 14.8839C9.51821 14.8839 9.10061 14.8119 8.68301 14.7111L7.26221 16.1319C11.3422 17.8167 15.7678 15.6039 18.9358 9.48394C18.331 8.31274 17.6782 7.29034 16.9918 6.40234Z" fill="#9B9D9C" />
                      </svg>
                    </span>}
                    {showPassword.newpassword && <span className="showEye"
                      onClick={() => setShowPassword((prev) => ({
                        ...prev, newpassword: false
                      }))}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path d="M5.53924 3.34415C7.67955 1.85471 10.0464 1.35887 12.6096 2.36975C16.5452 3.92159 18.936 9.01295 18.936 9.01295C18.6116 9.71471 17.1298 12.251 15.72 13.525C14.4111 14.7077 12.6096 15.661 12.6096 15.661C10.8284 16.369 8.68756 16.571 6.14452 15.0989C2.73556 12.9936 0.936035 9.01295 0.936035 9.01295C1.2778 8.25215 3.049 5.01119 5.53924 3.34415ZM6.925 13.5624C8.94436 14.6674 10.6445 14.5157 12.0591 13.9843C12.0591 13.9843 13.4895 13.2691 14.5292 12.3816C15.6485 11.4254 16.8255 9.52223 17.0832 8.99567C17.0832 8.99567 15.1848 5.17487 12.0596 4.01039C10.0239 3.25199 8.14467 3.62399 6.44499 4.74191C4.46739 5.99279 3.061 8.42495 2.78979 8.99567C2.78979 8.99567 4.21875 11.9827 6.92595 13.5624H6.925Z" fill="white" />
                        <path d="M9.93577 5.44336C11.9124 5.44336 13.5146 7.0456 13.5146 9.02224C13.5146 10.9989 11.9124 12.6011 9.93577 12.6011C7.95913 12.6011 6.35689 10.9989 6.35689 9.02224C6.35689 7.0456 7.95913 5.44336 9.93577 5.44336ZM10.843 8.10976C11.3407 8.10976 11.7444 7.70608 11.7444 7.20832C11.7444 6.71056 11.3407 6.30688 10.843 6.30688C10.3452 6.30688 9.94153 6.71056 9.94153 7.20832C9.94153 7.70608 10.3452 8.10976 10.843 8.10976Z" fill="white" />
                      </svg>
                    </span>}
                  </>}
                </div>
                <p className="error" style={{ opacity: errors.newpassword ? 1 : 0 }}>{errors.newpassword}.</p>
              </div>


              <div className="field">
                <div className="password">
                  <input className="Pswrd" type={showPassword.confirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    onBlur={() => { matchpass() }}
                    name="Password" id="cnfpassword" placeholder='Confirm Password*' required />

                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                      <path d="M5.32263 8.38487C8.76609 8.50991 12.3768 8.18006 15.8014 8.37221C16.8155 8.42898 17.6076 8.88041 17.9731 9.72881C18.0981 10.0188 18.1556 10.3333 18.1556 10.6489L18.1541 18.2113C18.1541 18.846 17.8983 19.4601 17.4284 19.8874C17.0829 20.2015 16.6395 20.409 16.1462 20.4577L5.00543 20.4558C4.00247 20.3039 3.20009 19.4946 3.07275 18.4863L3.07659 10.6957C3.07697 9.60339 3.83601 8.64069 4.90763 8.42936C5.04225 8.4029 5.1811 8.38794 5.32263 8.38525V8.38487ZM11.6714 12.6311C10.3018 11.2634 8.22721 13.3161 9.52129 14.6831C9.61104 14.7778 9.86878 14.9155 9.88604 15.0068C9.92362 15.5625 9.83541 16.1812 9.88412 16.7293C9.96466 17.6325 11.2591 17.6551 11.342 16.7293C11.3922 16.1697 11.2963 15.5426 11.3466 14.9753C12.18 14.479 12.371 13.3299 11.6711 12.6311H11.6714Z" fill="#9B9D9C" />
                      <path d="M11.6714 12.6286C12.3714 13.3275 12.18 14.4766 11.3469 14.9729C11.2963 15.5401 11.3922 16.1672 11.3423 16.7268C11.2595 17.6527 9.96502 17.6301 9.88448 16.7268C9.83577 16.1791 9.92398 15.5605 9.88639 15.0043C9.86875 14.913 9.61101 14.7753 9.52164 14.6806C8.22756 13.3136 10.3018 11.2609 11.6714 12.6286Z" fill="#1F222B" />
                      <path d="M14.6314 2.65765C13.864 1.6915 12.5388 0.981563 11.3019 0.878773C10.9364 0.848473 10.2882 0.846938 9.9238 0.878773C8.53575 1.00036 7.17072 1.81922 6.39366 2.95413C5.4417 4.3441 5.13215 6.82118 5.20502 8.47272L7.42638 8.47904C7.35389 6.91226 7.71842 4.06679 9.38952 3.38447C10.2567 3.03046 11.537 3.08454 12.3175 3.6307C13.5744 4.51017 13.6568 6.2902 13.5989 7.68439L13.5552 8.54544L15.8653 8.37515L15.896 7.68439C15.9804 5.91816 15.7602 4.0783 14.6314 2.65765Z" fill="#9B9D9C" />
                    </svg>
                  </span>

                  {confirmPassword !== "" && <>
                    {!showPassword.confirmPassword && <span className="showEye"
                      onClick={() => setShowPassword((prev) => ({
                        ...prev, confirmPassword: true
                      }))}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path d="M17.664 0.484375L14.3328 3.81558C9.82084 0.613975 4.56004 2.48597 0.936035 9.48438C1.90564 11.3564 2.99524 12.854 4.15204 13.9964L0.936035 17.2124L2.20804 18.4844L18.936 1.75637L17.664 0.484375ZM9.03843 8.58197C8.53924 8.58197 8.13604 8.17877 8.13604 7.67957C8.13604 7.18037 8.53924 6.77718 9.03843 6.77718C9.53764 6.77718 9.94084 7.18037 9.94084 7.67957C9.94084 8.17877 9.53284 8.58197 9.03843 8.58197ZM11.76 6.38838C11.2272 6.07158 10.6032 5.88438 9.93604 5.88438C7.94884 5.88438 6.33604 7.49718 6.33604 9.48438C6.33604 10.1516 6.51844 10.7756 6.84004 11.3084L5.35683 12.7916C4.42564 11.9324 3.53764 10.8284 2.73604 9.48438C4.79044 6.03797 7.38244 4.08438 9.93604 4.08438C10.992 4.08438 12.0528 4.42998 13.08 5.06838L11.76 6.38838Z" fill="#9B9D9C" />
                        <path d="M16.9918 6.40234L15.811 7.58314C16.2718 8.15914 16.7182 8.78314 17.1358 9.48394C15.0814 12.9303 12.4894 14.8839 9.93581 14.8839C9.51821 14.8839 9.10061 14.8119 8.68301 14.7111L7.26221 16.1319C11.3422 17.8167 15.7678 15.6039 18.9358 9.48394C18.331 8.31274 17.6782 7.29034 16.9918 6.40234Z" fill="#9B9D9C" />
                      </svg>
                    </span>}
                    {showPassword.confirmPassword && <span className="showEye"
                      onClick={() => setShowPassword((prev) => ({
                        ...prev, confirmPassword: false
                      }))}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path d="M5.53924 3.34415C7.67955 1.85471 10.0464 1.35887 12.6096 2.36975C16.5452 3.92159 18.936 9.01295 18.936 9.01295C18.6116 9.71471 17.1298 12.251 15.72 13.525C14.4111 14.7077 12.6096 15.661 12.6096 15.661C10.8284 16.369 8.68756 16.571 6.14452 15.0989C2.73556 12.9936 0.936035 9.01295 0.936035 9.01295C1.2778 8.25215 3.049 5.01119 5.53924 3.34415ZM6.925 13.5624C8.94436 14.6674 10.6445 14.5157 12.0591 13.9843C12.0591 13.9843 13.4895 13.2691 14.5292 12.3816C15.6485 11.4254 16.8255 9.52223 17.0832 8.99567C17.0832 8.99567 15.1848 5.17487 12.0596 4.01039C10.0239 3.25199 8.14467 3.62399 6.44499 4.74191C4.46739 5.99279 3.061 8.42495 2.78979 8.99567C2.78979 8.99567 4.21875 11.9827 6.92595 13.5624H6.925Z" fill="white" />
                        <path d="M9.93577 5.44336C11.9124 5.44336 13.5146 7.0456 13.5146 9.02224C13.5146 10.9989 11.9124 12.6011 9.93577 12.6011C7.95913 12.6011 6.35689 10.9989 6.35689 9.02224C6.35689 7.0456 7.95913 5.44336 9.93577 5.44336ZM10.843 8.10976C11.3407 8.10976 11.7444 7.70608 11.7444 7.20832C11.7444 6.71056 11.3407 6.30688 10.843 6.30688C10.3452 6.30688 9.94153 6.71056 9.94153 7.20832C9.94153 7.70608 10.3452 8.10976 10.843 8.10976Z" fill="white" />
                      </svg>
                    </span>}
                  </>}
                </div>
                <p className="error" style={{ opacity: errors.confirmPassword ? 1 : 0 }}>{errors.confirmPassword}.</p>
              </div>

              <div className="loginBtn">
                <button type='submit' className="commonBtn">Update</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}


